import { Component, OnInit, Input } from '@angular/core';
import { GUID } from "app/brightserve/brightserve.module";

@Component({
	selector: '[app-quick-action-messages]',
	templateUrl: './quick-action-messages.component.html',
	styleUrls: ['./quick-action-messages.component.css']
})
export class QuickActionMessagesComponent implements OnInit {

	@Input() Id: GUID;
	NewMessages: number = 0;
	Messages: Array<Object>;

	constructor() { }

	ngOnInit() {
		this.Messages = [{
			"Id": "d5180918-7948-42cb-af51-02d0d9c55a60",
			"FirstName": "Fredelia",
			"LastName": "Antunes",
			"Name": "Fredelia Antunes",
			"Message": "Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus.\n\nCurabitur at ipsum ac tellus semper interdum. Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam.",
			"Sent": "2017-07-10T23:28:38Z",
			"New": true,
			"Me": false
		}, {
			"Id": "2a280da9-839b-47cb-bebc-294e390d1c4e",
			"FirstName": "Quinton",
			"LastName": "Everiss",
			"Name": "Quinton Everiss",
			"Message": "Sed sagittis. Nam congue, risus semper porta volutpat, quam pede lobortis ligula, sit amet eleifend pede libero quis orci. Nullam molestie nibh in lectus.\n\nPellentesque at nulla. Suspendisse potenti. Cras in purus eu magna vulputate luctus.",
			"Sent": "2017-07-04T12:36:44Z",
			"New": true,
			"Me": false
		}, {
			"Id": "dcb3464e-e406-4cb3-97a9-f1fc552d709e",
			"FirstName": "Maison",
			"LastName": "Dowsing",
			"Name": "Maison Dowsing",
			"Message": "Nulla ut erat id mauris vulputate elementum. Nullam varius. Nulla facilisi.",
			"Sent": "2017-07-22T13:19:49Z",
			"New": true,
			"Me": false
		}, {
			"Id": "5706c404-a5f8-4fda-a604-7e9c448c04e6",
			"FirstName": "Talya",
			"LastName": "Bordiss",
			"Name": "Talya Bordiss",
			"Message": "Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.",
			"Sent": "2017-07-20T21:10:19Z",
			"New": true,
			"Me": true
		}, {
			"Id": "28d6663f-9e82-4291-a598-e5028950c807",
			"FirstName": "Fraser",
			"LastName": "Wilcox",
			"Name": "Fraser Wilcox",
			"Message": "Cras mi pede, malesuada in, imperdiet et, commodo vulputate, justo. In blandit ultrices enim. Lorem ipsum dolor sit amet, consectetuer adipiscing elit.",
			"Sent": "2017-07-16T20:53:00Z",
			"New": true,
			"Me": false
		}, {
			"Id": "414f5700-92bc-4432-b76d-7ad35e4fd3a3",
			"FirstName": "Kristofer",
			"LastName": "Oager",
			"Name": "Kristofer Oager",
			"Message": "Proin eu mi. Nulla ac enim. In tempor, turpis nec euismod scelerisque, quam turpis adipiscing lorem, vitae mattis nibh ligula nec sem.\n\nDuis aliquam convallis nunc. Proin at turpis a pede posuere nonummy. Integer non velit.",
			"Sent": "2017-07-17T15:37:01Z",
			"New": true,
			"Me": true
		}, {
			"Id": "bfb2cba8-a17d-4a3a-891c-501ce6807ed8",
			"FirstName": "Dalila",
			"LastName": "MacCracken",
			"Name": "Dalila MacCracken",
			"Message": "Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.\n\nQuisque porta volutpat erat. Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla. Nunc purus.\n\nPhasellus in felis. Donec semper sapien a libero. Nam dui.",
			"Sent": "2017-07-19T14:48:18Z",
			"New": true,
			"Me": false
		}, {
			"Id": "af5f941d-7f66-4f74-b950-2816cfdf95ea",
			"FirstName": "Alejandrina",
			"LastName": "Schrir",
			"Name": "Alejandrina Schrir",
			"Message": "Vestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.\n\nIn congue. Etiam justo. Etiam pretium iaculis justo.",
			"Sent": "2017-07-19T18:02:50Z",
			"New": true,
			"Me": true
		}, {
			"Id": "6c015cb9-1c51-44cd-a80c-acc3a7f5436d",
			"FirstName": "Birk",
			"LastName": "Grief",
			"Name": "Birk Grief",
			"Message": "Cras non velit nec nisi vulputate nonummy. Maecenas tincidunt lacus at velit. Vivamus vel nulla eget eros elementum pellentesque.\n\nQuisque porta volutpat erat. Quisque erat eros, viverra eget, congue eget, semper rutrum, nulla. Nunc purus.",
			"Sent": "2017-07-17T14:52:04Z",
			"New": true,
			"Me": false
		}, {
			"Id": "5062e33d-f74a-4ecc-a363-45884ea51bf5",
			"FirstName": "Xymenes",
			"LastName": "Pedri",
			"Name": "Xymenes Pedri",
			"Message": "Morbi non lectus. Aliquam sit amet diam in magna bibendum imperdiet. Nullam orci pede, venenatis non, sodales sed, tincidunt eu, felis.\n\nFusce posuere felis sed lacus. Morbi sem mauris, laoreet ut, rhoncus aliquet, pulvinar sed, nisl. Nunc rhoncus dui vel sem.",
			"Sent": "2017-07-20T10:04:43Z",
			"New": true,
			"Me": true
		}];
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/quick-action-messages.component.ts